import styled from "styled-components";

export const DietListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12rem;
  margin-top: 16rem;
`;
